import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { cases } from "@/mocks/cases";
import { evidenceTypes } from "@/mocks/site";

export default function EvidenceSection() {
  const demo = cases.find((c) => c.id === "case-01") ?? cases[0];

  return (
    <section id="evidence" className="w-full bg-background-100 border-y border-background-200">
      <div className="px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="Evidence Chain"
          title="证据链专区：实锤截图、录音与细节逐项对应"
          desc="我们不只给出结论，也把支撑结论的材料摊开。每一类证据都标注出处与可核对程度，无法印证的部分明确写「待补充」。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 flex flex-col gap-4">
            {evidenceTypes.map((item) => (
              <div
                key={item.key}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-300"
              >
                <span className="flex w-11 h-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    {item.title}
                    <span className="ml-2 text-xs font-normal text-secondary-700">· {item.key}</span>
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="lg:col-span-7 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <div className="flex items-center justify-between gap-4 pb-5 border-b border-background-200">
              <div className="min-w-0">
                <p className="text-xs tracking-widest text-foreground-500 uppercase">时间线示例</p>
                <h3 className="mt-1.5 font-heading text-base md:text-lg font-bold text-foreground-950 truncate">
                  {demo.title}
                </h3>
              </div>
              <Link
                to={`/archive/${demo.id}`}
                className="shrink-0 inline-flex items-center gap-1.5 px-3.5 py-2 rounded-md bg-primary-100 text-primary-800 text-xs font-medium whitespace-nowrap hover:bg-primary-200 transition-colors cursor-pointer"
              >
                查看档案
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <ol className="mt-6 relative">
              <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true" />
              {demo.timeline.map((node, index) => (
                <li key={`${node.time}-${index}`} className="relative flex gap-4 pb-6 last:pb-0">
                  <span
                    className={`relative z-10 mt-1 flex w-4 h-4 shrink-0 items-center justify-center rounded-full ${
                      index === demo.timeline.length - 1 ? "bg-accent-500" : "bg-primary-500"
                    }`}
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50" />
                  </span>
                  <div className="min-w-0">
                    <p className="text-xs font-medium text-foreground-500">{node.time}</p>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-800">{node.event}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-6 rounded-md bg-background-100 border border-background-200 p-4">
              <p className="text-xs font-medium text-foreground-500 mb-1.5">当前核对结论</p>
              <p className="text-sm leading-relaxed text-foreground-800">{demo.conclusion}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}